<template>
    <div class="row animated fadeIn">
        <div class="col-md-8 offset-md-2">

            <div class="card">
                <div class="card-header">
                    <i class="fa fa-align-justify"></i> <strong>Lista de Eventos</strong>
                    <router-link :to="'/shaw/event'" class="btn btn-secondary btn-sm pull-right" exact>
                        <i class="fa fa-plus"></i> Novo Evento
                    </router-link>
                </div>
                <div class="card-block">
                    <table class="table table-bordered">
                        <thead class="thead-inverse">
                            <tr>
                                <th>Evento</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(row, rowIndex) in events">
                                <td>
                                    <router-link :to="'event/' + row.name">{{ row.name }}</router-link>
                                </td>
                                <td class="actions">
                                    <button type="button" class="btn btn-link" @click="showModal(row)" style="margin:0"><i class="fa fa-trash"></i>
                                    </button>
                                    <button type="button" class="btn btn-link" @click="showTestModal(row.schema)">
                                        <i class="fa fa-play-circle"></i>
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    <modal title="Modal title" class="modal" v-model="deleteModal" @ok="deleteModal = false" effect="fade/zoom">
                        <div slot="modal-header" class="modal-header">
                            <span class="modal-title"><strong>Excluir Evento</strong></span>
                        </div>
                        <div slot="modal-body" class="modal-body">Deseja excluir o evento: <strong>{{ event.name }}</strong>?</div>
                        <div slot="modal-footer" class="modal-footer">
                            <button type="button" class="btn btn-sm btn-default" @click="deleteModal = false">Cancelar</button>
                            <button type="button" class="btn btn-sm btn-danger" @click.prevent="deleteEvent">Confirmar</button>
                        </div>
                    </modal>
                    <modal title="Modal title" class="modal" v-model="testModal" effect="fade/zoom">
                        <div slot="modal-header" class="modal-header">
                            <span class="modal-title">
                              <strong>Exemplo</strong>
                            </span>
                        </div>
                        <div slot="modal-body" class="modal-body">
                            <div class="card">
                                <div class="card-block">
                                    <vue-json-editor v-model="jsonSample" mode="code" :showBtns="false"></vue-json-editor>
                                </div>
                            </div>
                        </div>
                        <div slot="modal-footer" class="modal-footer">
                            <button type="button" class="btn btn-sm btn-default" @click="testModal = false">Fechar</button>
                        </div>
                    </modal>
                </div>
            </div>
        </div>
    </div>
    </div>
</template>
<script>
import axios from 'axios'
import modal from 'vue-strap/src/Modal'
import vueJsonEditor from 'vue-json-editor'
import jsf from 'json-schema-faker'

export default {
  name: 'templates',
  components: {
    modal,
    vueJsonEditor
  },
  data () {
    return {
      loading: false,
      deleteModal: false,
      testModal: false,
      jsonSample: {},
      event: {},
      events: []
    }
  },
  created () {
    this.getEvents()
  },
  methods: {
    getEvents () {
      axios.get(process.env.SHAW_API_URL + 'configurations', {
        withCredentials: true,
        headers: { Authorization: this.accessKey }}).then(response => {
          this.events = response.data
        }).catch(err => {
          console.error(err)
          this.showError('Ops. Ocorreu um erro ao carregar os eventos.')
        })
    },
    deleteEvent () {
      this.deleteModal = false
      axios.delete(process.env.SHAW_API_URL + 'configurations/' + this.event.name, {
        withCredentials: true,
        headers: { Authorization: this.accessKey,
          'Content-Type': 'application/json' }}).then(response => {
            this.showSuccess('Evento excluido com sucesso')
            this.getEvents()
          }).catch(err => {
            console.error(err)
            this.showError('Ops. Ocorreu um erro ao excluir o evento.')
          })
    },
    showModal (row) {
      this.event = row
      this.deleteModal = true
    },
    showTestModal(item) {
      this.jsonSample = jsf(JSON.parse(item))
      this.testModal = true
    }
  }
}
</script>
<style>
.jsoneditor-vue div.jsoneditor-tree {
  min-height: 350px !important
}
.ace-jsoneditor {
  min-height: 350px !important
}
</style>



// WEBPACK FOOTER //
// Index.vue?2cc1cc4a